import React from 'react'
import './footer.css'
import { Row, Col, Layout } from 'antd';
import facebooklogo from '../../assets/img/facebook.svg'
import twitterlogo from '../../assets/img/twitter.svg'
import dribblelogo from '../../assets/img/dribble.svg'

const Footer = () => {

    const { Footer } = Layout;
    let date = new Date();
    let year = date.getFullYear();

    return(
        <Footer>
            <div className="footer">
                <section>

                    <Row className="footer_contact_holder">
                        <div className="footer_contact_us">
                            <p>Questions? Contact us</p>
                        </div>
                    </Row>
                    
                    <Row gutter={[16, 24]} className="footer_links_holder">
                        <Col className="gutter-row footer_links" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>    
                            <ul>
                                <li>About us</li>
                                <li>Investor Relations</li>
                                <li>Help & FAQ</li>
                                <li>Latency Test</li>
                            </ul>
                        </Col>
                        <Col className="gutter-row footer_links" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <ul>
                                <li>Career</li>
                                <li>Help Center</li>
                                <li>Legal Notices</li>
                                <li>Cookie Preferences</li>
                            </ul>
                        </Col>
                        <Col className="gutter-row footer_links" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <ul>
                                <li>Ways to Play</li>
                                <li>Account</li>
                                <li>PlayarOne Sponsored</li>
                                <li>Corporate Information</li>
                            </ul>
                        </Col>
                        <Col className="gutter-row footer_links" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <ul>
                                <li>Media Center</li>
                                <li>Contact us</li>
                                <li>Terms of Use</li>
                                <li>Discord Community</li>
                            </ul>
                        </Col>
                    </Row>
                
                    <div className="footer_bottom">
                        <ul>
                            <li>&copy; Copyright {year} PlayarOne</li>
                        </ul>

                        <ul>
                            <li><img src={facebooklogo} alt=""/></li>
                            <li><img src={twitterlogo} alt=""/></li>
                            <li><img src={dribblelogo} alt=""/></li>
                        </ul>
                    </div>
                
                </section>
            </div>
        </Footer>
    );
}

export default Footer;